import { useRequest, API_PATH } from '../hooks/useRequest';
/**
 * ============================================
 * C端 - 抽奖接口
 * ============================================
 */
/**
 * Hook - 抽奖
 * @returns 包含请求函数和状态的对象
 */
export const useDraw = () => {
    return useRequest(API_PATH.DRAW_PRIZE);
};
